import { render, staticRenderFns } from "./DrivewealthInvestmentAccountList.vue?vue&type=template&id=ba2e4ad6"
import script from "./DrivewealthInvestmentAccountList.vue?vue&type=script&lang=ts"
export * from "./DrivewealthInvestmentAccountList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports